var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g2, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasa404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 427,
    viewBox: "0 0 539 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.7 282.513L358.055 312.137V161.498L181.986 59.9346V210.574L306.7 282.513Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.387 124.962L534.139 171.149V162.689L343.387 116.502V124.962Z",
    fill: "#493986"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.333 14.9092L343.387 116.502L534.14 162.689L358.086 61.081L167.333 14.9092Z",
    fill: "#57428E",
    stroke: "url(#paint0_linear_1396_2329)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.333 14.9092L343.387 116.502V124.962L167.333 23.369V14.9092Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M354.762 311.481L516.177 218.378V167.782L354.762 128.715V311.481Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.393 168.751L358.056 161.646V312.137L387.393 295.202V168.751Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M519.471 170.508C514.015 174.127 509.572 179.31 507.053 185.357C503.788 193.162 503.028 202.888 496.066 207.698C490.491 211.556 482.963 210.633 476.508 212.718C469.725 214.907 464.21 220.701 462.361 227.582C461.914 229.235 461.661 230.963 460.766 232.423C457.74 237.382 450.316 236.012 444.711 237.531C431.25 241.195 428.656 262.047 415.21 265.756C412.854 266.411 410.305 266.456 408.084 267.484C403.582 269.554 401.54 275.05 397.217 277.478C393.609 279.503 389.197 279.026 385.067 278.818C375.944 278.371 366.746 279.652 358.07 282.497V312.121L519.486 219.018V170.508H519.471Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M358.056 139.245L519.471 178.327V168.438L358.056 129.355V139.245Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M402.867 202.649L461.542 168.795V236.504L402.867 270.358V202.649Z",
    fill: "#455A64"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M459.202 235.163V170.15L402.867 202.649V267.633L459.202 235.163Z",
    fill: "#BA68C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M459.202 235.163V170.15L402.867 202.649V267.633L459.202 235.163Z",
    fill: "#493986"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M459.202 218.08L418.803 258.443L435.961 248.553L459.202 225.333V218.08ZM402.867 242.059V266.977L459.202 210.692V185.774L402.867 242.059Z",
    fill: "#493986"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M459.202 170.15V180.502L402.867 213.001V202.649L459.202 170.15Z",
    fill: "#493986"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M461.542 236.504L459.202 235.163L402.867 267.632V270.358L461.542 236.504Z",
    fill: "#37474F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M434.559 184.359L432.204 185.715V253.423L434.559 252.083V184.359Z",
    fill: "#455A64"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M432.205 185.715V253.424L429.85 252.083V187.07L432.205 185.715Z",
    fill: "#37474F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.001 427V296.259L17.248 186.236V316.962L208.001 427Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M206.689 395.172C199.429 391.984 190.425 394.755 183.493 390.927C178.514 388.171 175.682 382.556 170.807 379.652C162.981 374.99 152.71 378.639 143.974 376.018C135.417 373.456 130.871 366.545 125.459 359.441C120.048 352.336 111.968 343.995 103.039 343.936C97.5976 343.906 91.1726 346.334 87.3564 342.476C85.6421 340.748 85.0607 338.187 83.5551 336.265C81.0059 333.033 76.3549 332.244 73.3734 329.414C68.3497 324.648 69.5572 315.89 64.9509 310.707C62.6402 308.1 59.2265 306.834 56.2898 304.988C42.2919 296.185 41.0993 276.54 32.7364 262.286C28.9947 255.896 23.5983 250.52 17.2627 246.662V316.933L208 426.956V395.797C207.568 395.603 207.151 395.38 206.689 395.172ZM125.966 355.494C126.652 356.298 127.397 357.117 128.396 357.46C128.858 357.623 129.425 357.653 129.782 357.326C129.946 357.177 130.036 356.953 130.095 356.745C130.364 355.687 129.678 354.645 129.037 353.751C128.381 352.842 124.729 347.287 123.134 350.489C122.776 351.204 123.253 352.023 123.715 352.664C124.446 353.632 125.191 354.57 125.966 355.494Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.248 186.236L17.263 228.551L208.001 338.574V296.259L17.248 186.236Z",
    fill: "#E0E0E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.269 252.351L31.9316 235.432V281.514L61.269 298.449V252.351Z",
    fill: "#455A64"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2871 280.159V236.787L61.2692 252.351V295.723L34.2871 280.159Z",
    fill: "#BA68C8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.2871 280.159V236.787L61.2692 252.351V295.723L34.2871 280.159Z",
    fill: "#493986"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2692 279.712L34.2871 252.739V256.656V263.909V277.672L61.2841 304.645V290.883V283.629V279.712H61.2692ZM34.2871 304.317L61.2841 331.291V324.037L34.2871 297.064V304.317ZM34.2871 193.445V233.213L61.2841 260.186V220.419L34.2871 193.445Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M34.2871 236.787L61.2692 252.351V260.365L34.2871 244.904V236.787Z",
    fill: "#493986"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9316 281.515L34.287 280.159L61.269 295.724V298.449L31.9316 281.515Z",
    fill: "#37474F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M163.965 283.108L105.29 249.254V316.963L163.965 350.817V283.108Z",
    fill: "#455A64"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.646 315.622V250.609L163.965 283.108V348.106L107.646 315.622Z",
    fill: "#BA68C8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.646 315.622V250.609L163.965 283.108V348.106L107.646 315.622Z",
    fill: "#493986"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.646 305.613L131.318 329.265L148.477 339.155L107.631 298.345V305.613H107.646ZM107.646 266.069V290.987L163.98 347.272V322.354L107.646 266.069Z",
    fill: "#493986"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M107.646 250.609V260.961L163.965 293.475V283.108L107.646 250.609Z",
    fill: "#493986"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.29 316.963L107.645 315.622L163.965 348.106V350.817L105.29 316.963Z",
    fill: "#37474F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.272 264.818L134.628 266.189V333.897L132.272 332.557V264.818Z",
    fill: "#455A64"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M134.627 266.188V333.897L136.982 332.542V267.529L134.627 266.188Z",
    fill: "#37474F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M208.001 301.86L354.718 149.522V342.357L208.001 427V301.86Z",
    fill: "#FAFAFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M354.717 309.933C350.111 313.567 346.429 318.363 344.163 323.784C341.539 330.084 340.019 338.053 333.713 340.659C331.253 341.672 328.421 341.642 326.066 342.878C321.146 345.44 320.207 352.232 316.048 355.881C308.997 362.077 297.608 356.328 288.708 359.322C279.033 362.583 275.784 374.514 268.479 381.663C266.004 384.091 263.038 385.952 260.101 387.814C257.85 389.244 255.584 390.659 253.333 392.089C252.603 392.55 251.828 393.027 250.963 393.116C249.189 393.31 247.624 391.895 245.85 391.716C242.958 391.433 240.841 394.382 239.813 397.108C238.784 399.819 237.889 402.991 235.311 404.317C232.165 405.94 228.215 403.915 224.831 404.987C223.787 405.315 222.818 405.94 221.715 406.059C218.734 406.402 216.781 403.215 214.947 400.832C213.129 398.463 210.699 396.557 207.971 395.306V426.986L354.687 342.342V309.933H354.717Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M208.001 302.47L354.718 150.684V128.328L208.001 280.68V302.47Z",
    fill: "#F0F0F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M270.134 249.581L346.802 205.346V327.493L270.134 371.728V249.581Z",
    fill: "#455A64"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M343.731 325.75V207.118L270.134 249.581V368.183L343.731 325.75Z",
    fill: "#BA68C8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M343.731 325.75V207.118L270.134 249.581V368.183L343.731 325.75Z",
    fill: "#493986"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.731 289.706V264.788L270.134 338.32V363.238L343.731 289.706Z",
    fill: "#493986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.134 315.279V322.533L343.731 249.001V241.747L270.134 315.279Z",
    fill: "#493986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.73 311.437V304.198L292.718 355.151L309.876 345.261L343.73 311.437Z",
    fill: "#493986"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M343.731 207.118V220.642L270.134 263.12V249.581L343.731 207.118Z",
    fill: "#493986"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M346.802 327.493L343.731 325.75L270.134 368.183V371.728L346.802 327.493Z",
    fill: "#37474F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M311.546 225.691L308.476 227.464V349.611L311.546 347.868V225.691Z",
    fill: "#455A64"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M308.475 227.464V349.611L305.39 347.853V229.221L308.475 227.464Z",
    fill: "#37474F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M214.545 423.173V329.831L258.566 304.437V397.793L214.545 423.173Z",
    fill: "#37474F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M257.179 396.736V305.241L214.56 329.831V421.326L257.179 396.736Z",
    fill: "#76BDED"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M258.566 304.437L257.18 305.241V396.735L258.566 397.793V304.437Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M195.985 291.151L359.95 121.522V113.047L195.985 282.691V291.151Z",
    fill: "#493986"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M195.985 291.151L0 178.104V169.645L195.985 282.691V291.151Z",
    fill: "#493986"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M163.979 0L359.949 113.046L195.985 282.691L0 169.644L163.979 0Z",
    fill: "#493986"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1396_2329",
    x1: 162.474,
    y1: 88.7962,
    x2: 538.992,
    y2: 88.7962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasa404);
export default __webpack_public_path__ + "static/media/casa404.ec3271fd635c0b62fde9a16b36cbb012.svg";
export { ForwardRef as ReactComponent };